export type TaskStatus =
  | 'pending'
  | 'processing'
  | 'done'
  | 'overdue'
  | 'cancelled'

export type TaskPriority = 'low' | 'normal' | 'high' | 'urgent'

export type TaskFilterStatus = TaskStatus | 'all'

export interface TaskRecord {
  id: string
  title: string
  description?: string
  status: TaskStatus
  priority: TaskPriority
  module: string
  bizType: string
  assignee: string
  creator: string
  dueTime?: string
  createTime: string
  /** 关联业务路由或 Tab name */
  bizTab?: string
  payload?: Record<string, unknown>
}

export interface TaskActionLog {
  time: string
  operator: string
  action: string
  remark?: string
}

export interface TaskSummaryStats {
  pending: number
  processing: number
  overdue: number
  doneToday: number
}

export const STATUS_TAG_MAP: Record<
  TaskStatus,
  { type: 'info' | 'primary' | 'success' | 'danger' | 'warning'; label: string }
> = {
  pending: { type: 'info', label: '待处理' },
  processing: { type: 'primary', label: '进行中' },
  done: { type: 'success', label: '已完成' },
  overdue: { type: 'danger', label: '已逾期' },
  cancelled: { type: 'info', label: '已取消' },
}

export const PRIORITY_TAG_MAP: Record<
  TaskPriority,
  {
    type: 'info' | 'primary' | 'success' | 'danger' | 'warning' | ''
    label: string
  }
> = {
  low: { type: 'info', label: '低' },
  normal: { type: '', label: '普通' },
  high: { type: 'warning', label: '高' },
  urgent: { type: 'danger', label: '紧急' },
}
